export const CoreDataSecurityApplicationsName = 'CoreDataSecurityApplications';
